// extracted by mini-css-extract-plugin
export default {"focusTrap":"focusTrap___u3kpv"};